import { useTranslation } from "react-i18next";
import React, { useState, useEffect, Fragment, useCallback } from "react";
import { useNavigate, useParams, Prompt } from "react-router-dom";
import apiRequest from "../../functions/api";
import {
  TextField,
  Typography,
  MenuItem,
  Table,
  Hidden,
  TableBody,
  TableCell,
  TableContainer,
  useMediaQuery,
  TableHead,
  TableRow,
  Button,
  Box,
  Select,
} from "@mui/material";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { useMessage } from "../../context/message-context";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import RefreshIcon from "@mui/icons-material/Refresh";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Grid from "@mui/material/Grid";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import Child from "./child";
import { useTheme } from "@mui/material/styles";
import openFile from "../shared/functions/download";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import { FullPageSpinner } from "../lib";
import { ObjectContentIsEqual } from "../../functions/default";
import { SettingsVoice } from "@mui/icons-material";
import { setColor2, roundTo } from "../../functions/default";
import MessageBox from "../shared/components/MessageBox";
import NavigationPrompt from "../shared/components/NavigationPrompt";
//import {Promt } from 'react-router';
function Entgeltantrag(props, { navigation }) {
  const { t } = useTranslation();
  // Standard Variablen
  const { client, accessToken } = props;
  const { antragid } = useParams();
  const { showErrorMessage, showSuccessMessage } = useMessage();
  const [isLoading, setIsLoading] = useState(false);
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  const navigate = useNavigate();
  const [open, setOpen] = useState(-1);
  const [mopen, setMopen] = useState(-1);
  const [showModal, setShowModal] = useState(false);

  // Arbeitsvariablen
  const [zeitraum, setZeitraum] = useState([]);
  const [zeitraumIndex, setZeitraumIndex] = useState("");
  const [zeilen, setZeilen] = useState({});
  const [mzeilen, setMzeilen] = useState({});
  const [prfZeilen, setPrfZeilen] = useState({});
  const [prfMzeilen, setPrfMzeilen] = useState({});
  const [mzeile, setMzeile] = useState();
  const [spalten, setSpalten] = useState([]);
  const [mspalten, setMspalten] = useState([]);

  const [status, setStatus] = useState("");
  const [statustext, setStatustext] = useState("");
  const [genehmigen, setGenehmigen] = useState("0");
  const [vdat, setVdat] = useState("");
  const [bdat, setBdat] = useState("");
  const [formular, setFormular] = useState(0);
  const [selectedFormular, setSelectedFormular] = useState("");
  const [alleFormulare, setAlleFormulare] = useState([]);
  const [antragsteller, setAntragsteller] = useState("");
  const [hinweisvg, setHinweisvg] = useState("");
  const [frei, setFrei] = useState("0");
  const [monattext, setMonattext] = useState("");
  const [tagaktiv, setTagaktiv] = useState("0");
  const [monataktiv, setMonataktiv] = useState("0");
  const [key, setKey] = useState("");
  const [zeitjournal, setZeitjournal] = useState("");
  const [vg, setVg] = useState("");
  const theme = useTheme();
  const small = useMediaQuery(theme.breakpoints.down("lg"));
  const [changes, setChanges] = useState(0);
  const [newtime, setNewtime] = useState(false);

  // Functions
  useEffect(() => {
    setIsLoading(true);
    if (antragid) {
      const payload = {
        mandant: client,
        program: "PMURA3",
        statement: "FORANT_GENEHMIGEN",
        key: antragid,
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "daten", payload, headers, postGenehmigen);
    } else {
      const payload = {
        mandant: client,
        program: "FORANT",
        statement: "ANTRAG_LADEN",
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "daten", payload, headers, postAntragLaden);
    }
    // eslint-disable-next-line
  }, []);

  const postAntragLaden = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      if (!response.data.formular) {
        showErrorMessage(t("Es sind keine Antragsdaten hinterlegt. Bitte wenden Sie sich an Ihre Personalabteilung"));
        navigate(-1);
      } else {
        setAlleFormulare(response.data.formulare);
        setZeitraum(response.data.zeitraum);
        setZeitraumIndex("0");
        setStatus(response.data.status);
        setGenehmigen(response.data.genehmigen);
        setStatustext(response.data.statustext);
        setVdat(response.data.vdat);
        setBdat(response.data.bdat);
        if (response.data.zeilen) setZeilen(response.data.zeilen);
        if (response.data.mzeilen) setMzeilen(response.data.mzeilen);
        if (response.data.zeilen) setPrfZeilen(JSON.parse(JSON.stringify(response.data.zeilen)));
        if (response.data.mzeilen) setPrfMzeilen(JSON.parse(JSON.stringify(response.data.mzeilen)));
        if (response.data.newtime === "J") setNewtime(response.data.newtime);
        setMzeile(response.data.mzeile);
        setSpalten(response.data.spalten);
        setMspalten(response.data.mspalten);
        setHinweisvg(response.data.hinweisvg);
        setFormular(response.data.formular);
        setAntragsteller(response.data.antragsteller);
        setFrei(response.data.frei);
        setMonattext(response.data.monattext);
        setTagaktiv(response.data.tagaktiv);
        setMonataktiv(response.data.monataktiv);
        setKey(response.data.key);
        setZeitjournal(response.data.zeitjournal);
        setChanges(0);
        forceUpdate();
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
      navigate(-1);
    }
  };
  const postGenehmigen = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      setZeitraum(response.data.zeitraum);
      setZeitraumIndex("0");
      setStatus(response.data.status);
      setGenehmigen(response.data.genehmigen);
      setStatustext(response.data.statustext);
      setVdat(response.data.vdat);
      setBdat(response.data.bdat);
      if (response.data.vg) setVg(response.data.vg);
      if (response.data.zeilen) setZeilen(response.data.zeilen);
      if (response.data.mzeilen) setMzeilen(response.data.mzeilen);
      setMzeile(response.data.mzeile);
      if (response.data.zeilen) setPrfZeilen(JSON.parse(JSON.stringify(response.data.zeilen)));
      if (response.data.mzeilen) setPrfMzeilen(JSON.parse(JSON.stringify(response.data.mzeilen)));
      setSpalten(response.data.spalten);
      setMspalten(response.data.mspalten);
      setHinweisvg(response.data.hinweisvg);
      setFormular(response.data.formular);
      setAntragsteller(response.data.antragsteller);
      setFrei(response.data.frei);
      setMonattext(response.data.monattext);
      setTagaktiv(response.data.tagaktiv);
      setMonataktiv(response.data.monataktiv);
      setKey(response.data.key);
      setZeitjournal(response.data.zeitjournal);
      setChanges(0);
      forceUpdate();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  function Aktion(aufgabe) {
    setIsLoading(true);
    if (aufgabe === "genehmigen") {
      const payload = {
        mandant: client,
        program: "PMURA3",
        statement: "FORANT_ANTRAG_GENEHMIGEN",
        zeilen: zeilen,
        mzeilen: mzeilen,
        mzeile: mzeile,
        vdat: vdat,
        bdat: bdat,
        status: status,
        tagaktiv: tagaktiv,
        monataktiv: monataktiv,
        formular: formular,
        hinweisvg: hinweisvg,
        key: antragid,
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "daten", payload, headers, postAktionGenehmigen);
    }
    if (aufgabe === "ablehnen") {
      const payload = {
        mandant: client,
        program: "PMURA3",
        statement: "FORANT_ANTRAG_ABLEHNEN",
        zeilen: zeilen,
        mzeilen: mzeilen,
        mzeile: mzeile,
        vdat: vdat,
        bdat: bdat,
        status: status,
        tagaktiv: tagaktiv,
        monataktiv: monataktiv,
        formular: formular,
        hinweisvg: hinweisvg,
        key: antragid,
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "daten", payload, headers, postAktionGenehmigen);
    }
    if (aufgabe === "aktualisieren") {
      const payload = {
        mandant: client,
        program: "FORANT",
        statement: "ANTRAG_AKTUALISIEREN",
        zeilen: zeilen,
        mzeilen: mzeilen,
        mzeile: mzeile,
        vdat: vdat,
        bdat: bdat,
        status: status,
        zr: zeitraum[zeitraumIndex].key,
        tagaktiv: tagaktiv,
        monataktiv: monataktiv,
        formular: formular,
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "daten", payload, headers, postAktion);
    }
    if (aufgabe === "aendern") {
      const payload = {
        mandant: client,
        program: "FORANT",
        statement: "ANTRAG_AENDERN",
        zeilen: zeilen,
        mzeilen: mzeilen,
        mzeile: mzeile,
        vdat: vdat,
        bdat: bdat,
        status: status,
        zr: zeitraum[zeitraumIndex].key,
        tagaktiv: tagaktiv,
        monataktiv: monataktiv,
        formular: formular,
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "daten", payload, headers, postAktion);
    }
    if (aufgabe === "personal") {
      navigate("/FORANT/personal/" + key + genehmigen);
    }
    if (aufgabe === "kenntnis") {
      const payload = {
        mandant: client,
        program: "PMURA3",
        statement: "ANTRAG_KENNTNIS",
        key: key,
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      apiRequest("POST", "daten", payload, headers, postAktionGenehmigen);
    }
  }
  const postAktion = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      if (response.data.message === "OK") {
        if (response.data.successMessage) {
          showSuccessMessage(response.data.successMessage);
        }
        setStatus(response.data.status);
        setGenehmigen(response.data.genehmigen);
        setStatustext(response.data.statustext);
        setVdat(response.data.vdat);
        setBdat(response.data.bdat);
        if (response.data.zeilen) setZeilen(response.data.zeilen);
        if (response.data.mzeilen) setMzeilen(response.data.mzeilen);
        setMzeile(response.data.mzeile);
        if (response.data.zeilen) setPrfZeilen(JSON.parse(JSON.stringify(response.data.zeilen)));
        if (response.data.mzeilen) setPrfMzeilen(JSON.parse(JSON.stringify(response.data.mzeilen)));
        if (response.data.zeitraum) {
          setZeitraum(response.data.zeitraum);
        }
        // setZeitraumIndex("0");
        setSpalten(response.data.spalten);
        setMspalten(response.data.mspalten);
        setHinweisvg(response.data.hinweisvg);
        setFormular(response.data.formular);
        setAntragsteller(response.data.antragsteller);
        setFrei(response.data.frei);
        setMonattext(response.data.monattext);
        setTagaktiv(response.data.tagaktiv);
        setMonataktiv(response.data.monataktiv);
        setKey(response.data.key);
        setChanges(0);
        forceUpdate();
      } else {
        showErrorMessage(response.data.message);
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const postAktionGenehmigen = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      if (response.data.message === "OK") {
        navigate("/PMURA3/");
      } else {
        showErrorMessage(response.data.message);
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  function ChangeZR(zr) {
    if (zr === zeitraumIndex) return;
    var formularWechsel = false;
    if (zeitraum[zr]?.formulare.find((e) => e.key === formular)) {
    } else {
      formularWechsel = true;
      showErrorMessage(t("Aktuelles Formular im Zielmonat nicht vorhanden!"));
      setFormular(zeitraum[zr].formular);
    }

    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "FORANT",
      statement: "ANTRAG_ZR",
      zeilen: zeilen,
      mzeilen: mzeilen,
      mzeile: mzeile,
      vdat: vdat,
      bdat: bdat,
      status: status,
      zr: zeitraum[zr].key,
      tagaktiv: tagaktiv,
      monataktiv: monataktiv,
      formular: formularWechsel ? zeitraum[zr].formular : formular,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, postAktion);
  }
  function ChangeFR(FR) {
    // if (zr === zeitraumIndex) return;

    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "FORANT",
      statement: "ANTRAG_ZR",
      zeilen: zeilen,
      mzeilen: mzeilen,
      mzeile: mzeile,
      vdat: vdat,
      bdat: bdat,
      status: status,
      zr: zeitraum[zeitraumIndex].key,
      tagaktiv: tagaktiv,
      monataktiv: monataktiv,
      formular: FR,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, postAktion);
  }

  const openDL = () => {
    setShowModal(true);
    downloadFile(vdat.substr(0, 6));
  };
  const closeModal = () => {
    setShowModal(false);
  };
  function onInputChange(index, item) {
    zeilen[index] = item;
    if (!ObjectContentIsEqual(zeilen, prfZeilen) || !ObjectContentIsEqual(mzeilen, prfMzeilen)) {
      setChanges(1);
    } else {
      setChanges(0);
    }
  }
  function onInputChangeM(index, item) {
    mzeilen[index] = item;
    if (!ObjectContentIsEqual(zeilen, prfZeilen) || !ObjectContentIsEqual(mzeilen, prfMzeilen)) {
      setChanges(1);
    } else {
      setChanges(0);
    }
  }
  function openPanel(index) {
    setOpen(index);
  }
  function openPanelM(index) {
    setMopen(index);
  }
  function Abbrechen() {
    setOpen(-1);
    setMopen(-1);
    setZeilen(zeilen);
  }
  const downloadFile = (dlname) => {
    console.log("file with key: ", dlname);

    var pgm = "FORANT";
    if (genehmigen === "1") pgm = "PMURA3";
    const payload = {
      mandant: client,
      program: pgm,
      statement: "JOURNAL_LADEN_FORANT",
      timeperiod: vdat.substr(0, 6),
      key: key.substr(0, 7),
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };

    axios
      .post(API_BASE_URL + "daten", payload, { headers: headers, responseType: "blob" })
      .then((response) => {
        console.log(response);
        var fileName = key ? "Zeitjournal_" + dlname + "_" + key.substr(0, 7) + ".pdf" : "Zeitjournal_" + dlname + ".pdf";
        var contentFile = response.data;
        openFile(fileName, contentFile);
        closeModal();
      })
      .catch(function (error) {
        console.log(error);
        closeModal();
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  };
  //Anzeige
  function tableHeader() {
    return (
      <Fragment>
        <Hidden lgDown>
          <TableRow>
            <TableCell align="center">{t("Datum")}</TableCell>
            <TableCell align="center">{t("Info")}</TableCell>
            {(genehmigen === "1" || status === "A" || status === "N") && (
              <Hidden lgDown>
                <TableCell align="center">{t("Kommentar (Vorgesetzter)")}</TableCell>
              </Hidden>
            )}
            {spalten.map((item, index) => (
              <Hidden lgDown>
                <TableCell align="center">{item.bez}</TableCell>
              </Hidden>
            ))}
          </TableRow>
        </Hidden>
        <Hidden lgUp>
          <TableRow>
            <TableCell align="center">{t("Auswahl Tag")}</TableCell>
          </TableRow>
        </Hidden>
      </Fragment>
    );
  }
  function tableHeaderM() {
    return (
      <Fragment>
        <Hidden lgDown>
          <TableRow>
            <TableCell align="center">{t("Zeitraum")}</TableCell>
            {mspalten?.map((item, index) => (
              <Hidden lgDown>
                <TableCell align="center">{item.bez}</TableCell>
              </Hidden>
            ))}
          </TableRow>
        </Hidden>
        <Hidden lgUp>
          <TableCell align="center">{t("Monatswerte")}</TableCell>
        </Hidden>
      </Fragment>
    );
  }
  if (isLoading) {
    return <LoadingComponent />;
  }
  return (
    <Fragment>
      <NavigationPrompt when={changes === 1 && (status === "O" || status === "A")}>
        {(isOpen, onConfirm, onCancel) => (
          <MessageBox
            open={isOpen}
            handleResponse={(response) => {
              if (response === "YES") {
                onConfirm();
              } else {
                onCancel();
              }
            }}
            buttons="YESNO"
            text={t("Es sind Änderungen vorhanden, die noch nicht gespeichert wurden. Möchten Sie die Änderungen verwerfen und das Programm verlassen?")}
            title={t("ACHTUNG!")}
            onClose={() => onCancel()}
          />
        )}
      </NavigationPrompt>
      <ResponsiveDialog
        title={open >= 0 && zeilen && zeilen.length > 0 && zeilen[open].datum}
        open={open >= 0}
        setOpen={(o) => setOpen(-1)}
        actionButton={
          <Fragment>
            <Button color="primary" onClick={() => Abbrechen()}>
              {t("Zurück")}
            </Button>
          </Fragment>
        }
      >
        <Box p={2}>
          <form>
            {open >= 0 && zeilen && zeilen.length > 0 && (
              <Child
                key={zeilen[open].key}
                zeile={zeilen[open]}
                index={open}
                onChange={onInputChange}
                status={status}
                genehmigen={genehmigen}
                aufgabe="zeile"
                spalte={spalten}
                antragsteller={antragsteller}
                small={small}
                newtime={newtime}
              />
            )}
          </form>
        </Box>
      </ResponsiveDialog>
      <ResponsiveDialog
        title={mopen >= 0 && mzeilen && mzeile && mzeilen.length > 0 && mzeile.datum}
        open={mopen >= 0}
        setOpen={(o) => setMopen(-1)}
        actionButton={
          <Fragment>
            <Button color="primary" onClick={() => Abbrechen()}>
              {t("Zurück")}
            </Button>
          </Fragment>
        }
      >
        <Box p={2}>
          <form>
            {mopen >= 0 && mzeilen && mzeile && mzeilen.length > 0 && (
              <Child
                key={mzeile.key}
                zeile={mzeilen}
                index={mopen}
                onChange={onInputChangeM}
                status={status}
                genehmigen={genehmigen}
                aufgabe="zeilemonat"
                spalte={mspalten}
                datum={mzeile.datum}
                antragsteller={antragsteller}
                small={small}
                newtime={newtime}
              />
            )}
          </form>
        </Box>
      </ResponsiveDialog>
      <Grid container justifyContent="center">
        <Grid item>
          <Typography>{t("Entgeltantrag")}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container justifyContent="center" alignItems="flex-end">
            <Grid item xs={12} md={6}>
              <Grid container justifyContent="center">
                {vg && vg !== "" && (
                  <Grid item xs={12}>
                    <Typography align="center" fullWidth style={{ color: setColor2("255100100", 1) }}>
                      {"Stellvertretend für " + vg}
                    </Typography>
                  </Grid>
                )}
                {genehmigen === "1" && (
                  <Grid item xs={12} sm={6}>
                    <Box p={1}>
                      <TextField id="antragsteller" label={t("Antragsteller")} fullWidth disabled value={antragsteller} variant="outlined" />
                    </Box>
                  </Grid>
                )}
                {genehmigen !== "1" && (
                  <Grid item xs={12} sm={6}>
                    <Box p={1}>
                      <TextField
                        id="zeitraum"
                        label={t("Zeitraum")}
                        select
                        fullWidth
                        value={zeitraumIndex}
                        onChange={(e) => {
                          ChangeZR(e.target.value);
                          setZeitraumIndex(e.target.value);
                        }}
                        variant="outlined"
                      >
                        {zeitraum &&
                          zeitraum.map((item, index) => (
                            <MenuItem key={index} value={index}>
                              <Box sx={{ display: "flex", flexDirection: "column" }}>
                                <Typography>{item.bez}</Typography>
                                {/* <Typography variant="body2" color="text.secondary">This is a subtitle</Typography> */}
                              </Box>
                            </MenuItem>
                          ))}
                      </TextField>
                    </Box>
                  </Grid>
                )}
                {genehmigen === "1" && (
                  <Grid item xs={12} sm={6}>
                    <Box p={1}>
                      <TextField id="zeitraum" label={t("Zeitraum")} fullWidth disabled value={monattext} variant="outlined" />
                    </Box>
                  </Grid>
                )}
                <Grid item xs={12} sm={6}>
                  <Box p={1}>
                    {zeitraum ? (
                      <TextField
                        id="formular"
                        label={t("Formular")}
                        select
                        fullWidth
                        value={formular}
                        onChange={(e) => {
                          ChangeFR(e.target.value);
                          setFormular(e.target.value);
                        }}
                        variant="outlined"
                      >
                        {zeitraum[zeitraumIndex]?.formulare?.map((formular) => (
                          <MenuItem key={formular.key} value={formular.key}>
                            <Box sx={{ display: "flex", flexDirection: "column" }}>
                              <Typography>{formular.bez}</Typography>
                              <Typography variant="caption" color="text.secondary">
                                {t("Verfügbar: ") + formular.kommentar}
                              </Typography>
                            </Box>
                          </MenuItem>
                        ))}
                      </TextField>
                    ) : (
                      <TextField id="formular" label={t("Formular")} fullWidth disabled value={formular} variant="outlined" />
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box p={1}>
                    <TextField id="aktstatus" label={t("Aktueller Status")} fullWidth disabled value={statustext} variant="outlined" />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            {(status === "A" || status === "N") && (
              <Grid container justifyContent="center" alignItems="flex-end">
                <Grid item xs={12}>
                  <Box p={1}>
                    <TextField id="hinweisvg" label={t("Hinweis Vorgesetzter")} fullWidth disabled variant="outlined" value={hinweisvg} />
                  </Box>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
        {(status === "P" || status === "K" || frei === "1") && (
          <Grid item xs={12} sm={6} md={3}>
            <Box p={1}>
              <Button variant="contained" color="primary" fullWidth startIcon={<VisibilityIcon />} onClick={() => Aktion("personal")}>
                {t("Änderungen Personalabteilung")}
              </Button>
            </Box>
          </Grid>
        )}
        {tagaktiv === "1" && (
          <Grid item xs={12} md={10}>
            <Grid container justifyContent="center">
              <Grid item xs={12}>
                <TableContainer>
                  <Table size="small">
                    <TableHead>{tableHeader()}</TableHead>
                    <TableBody>
                      {zeilen?.map((item, index) => (
                        <Child
                          key={item.key}
                          zeile={item}
                          index={index}
                          onChange={onInputChange}
                          status={status}
                          genehmigen={genehmigen}
                          onClick={openPanel}
                          aufgabe="alles"
                          spalte={spalten}
                          small={small}
                          newtime={newtime}
                        />
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Grid>
        )}
        {monataktiv === "1" && (
          <Grid item xs={12} md={10}>
            <Box p={1}></Box>
            <Grid container justifyContent="center">
              <Grid item xs={12}>
                <TableContainer>
                  <Table size="small">
                    <TableHead>{tableHeaderM()}</TableHead>
                    <TableBody>
                      <Child
                        key={mzeile?.key}
                        zeile={mzeilen}
                        index={0}
                        onChange={onInputChangeM}
                        status={status}
                        genehmigen={genehmigen}
                        onClick={openPanelM}
                        aufgabe="allesmonat"
                        spalte={mspalten}
                        datum={mzeile?.datum}
                        small={small}
                        newtime={newtime}
                      />
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Grid>
        )}
        <Grid item xs={12}>
          <Grid container justifyContent="center" alignItems="flex-end">
            <Grid item xs={12}>
              {genehmigen === "1" && (
                <Grid container justifyContent="center" alignItems="flex-end">
                  <Grid item xs={12} sm={6}>
                    <Box p={1}>
                      <TextField
                        id="vghinweis"
                        label={t("Zusätzlicher Kommentar")}
                        disabled={status === "P" || status === "K" || frei === "1"}
                        fullWidth
                        value={hinweisvg}
                        onChange={(e) => {
                          setHinweisvg(e.target.value);
                        }}
                        variant="outlined"
                        style={genehmigen === "1" ? { backgroundColor: theme.palette.blocks.hyellow } : {}}
                      />
                    </Box>
                  </Grid>
                </Grid>
              )}
            </Grid>
            {genehmigen === "1" && status !== "P" && status !== "K" && frei !== "1" && (
              <Grid item xs={12} sm={6} md={3}>
                <Box p={1}>
                  <Button variant="contained" color="primary" fullWidth startIcon={<DoneIcon />} onClick={() => Aktion("genehmigen")}>
                    {t("Antrag genehmigen")}
                  </Button>
                </Box>
              </Grid>
            )}
            {genehmigen === "1" && status !== "P" && status !== "K" && frei !== "1" && (
              <Grid item xs={12} sm={6} md={3}>
                <Box p={1}>
                  <Button variant="outlined" color="primary" fullWidth startIcon={<CloseIcon />} onClick={() => Aktion("ablehnen")}>
                    {t("Antrag zurückschicken")}
                  </Button>
                </Box>
              </Grid>
            )}
            {(status === "O" || status === "A") && frei !== "1" && (
              <Grid item xs={12} sm={6} md={3}>
                <Box p={1}>
                  <Button variant="contained" color="primary" fullWidth startIcon={<RefreshIcon />} onClick={() => Aktion("aktualisieren")}>
                    {t("Speichern / Aktualisieren")}
                  </Button>
                </Box>
              </Grid>
            )}
            {genehmigen === "0" && (status === "O" || status === "A" || status === "B" || status === "N") && frei !== "1" && (
              <Grid item xs={12} sm={6} md={3}>
                <Box p={1}>
                  <Button variant="contained" color="primary" fullWidth startIcon={<DoneIcon />} onClick={() => Aktion("aendern")}>
                    {status === "O" || status === "A" ? "Monat abschließen / Antrag absenden" : "Monat bearbeiten"}
                  </Button>
                </Box>
              </Grid>
            )}

            {genehmigen === "1" && frei !== "1" && (status === "P" || status === "K") && (
              <Grid item xs={12} sm={6} md={3}>
                <Box p={1}>
                  <Button variant="contained" color="primary" fullWidth startIcon={<RefreshIcon />} onClick={() => Aktion("kenntnis")}>
                    {t("Zur Kenntnis nehmen")}
                  </Button>
                </Box>
              </Grid>
            )}
            {zeitjournal === "J" && (
              <Grid item xs={12} sm={6} md={3}>
                <Box p={1}>
                  <Button variant="contained" color="primary" fullWidth startIcon={<InsertDriveFileOutlinedIcon />} onClick={() => openDL()}>
                    {t("Zeitjournal drucken")}
                  </Button>
                </Box>
              </Grid>
            )}
            {showModal && <FullPageSpinner />}
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
}
export default Entgeltantrag;
